<template>
  <div class="LKPublicationsFormdataReport">
    <div class="LKPublicationsFormdataReport__header">
      <p
        class="LKPublicationsFormdataReport__header__title"
        v-text="title"
      />

      <ProgressCircular
        v-if="isLoadingShow"
        :size="20"
      />
    </div>

    <span v-if="isReportFailed" v-html="report.error_msg" />

    <button
      v-if="isReportDone"
      class="LKPublicationsFormdataReport__btn"
      :disabled="isLoading"
      @click="onDownloadReport"
      v-text="'Загрузить отчёт'"
    />

    <span v-if="isLoadingShow">Вы можете закрыть окно и найти результат формирования отчета в уведомлениях</span>
  </div>
</template>

<script>
import { downloadLinkByGet } from '@/helpers/downloadBlob'
import { ReportsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'
import { ReportCodes, ReportStatuses } from '@/typings/api/Report'

import ProgressCircular from '@/components/lk/LKProgressCircular.vue'

const STATUS_TIMEOUT = 5000

export default {
  components: {
    ProgressCircular,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
    reportCode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    isLoadingData: false,
    report: null,
  }),
  computed: {
    title() {
      if (!this.report) {
        return 'Создание отчёта'
      }

      switch (this.report.status) {
        case ReportStatuses.ready:
        case ReportStatuses.pending:
        case ReportStatuses.in_progress:
          return `Отчёт #${this.report.id} формируется`
        case ReportStatuses.done:
          return `Отчёт #${this.report.id} готов к загрузке`
        case ReportStatuses.error:
          return `Не удалось сформировать отчёт #${this.report.id}`
        default:
          return this.report.status
      }
    },
    isLoadingShow() {
      return this.isLoadingData || ![ReportStatuses.done, ReportStatuses.error].includes(this.report?.status)
    },
    isReportDone() {
      return this.report && this.report.status === ReportStatuses.done
    },
    isReportFailed() {
      return this.report
          && (this.report.status === ReportStatuses.error || (this.report.error_msg
              && ![ReportStatuses.in_progress, ReportStatuses.pending].includes(this.report?.status)))
    },
    ext() {
      const arr = this.report.raw_file.url.split('.')
      const ext = arr.length > 1 ? arr[arr.length - 1] : null
      return ext
    },
    filename() {
      const { ext } = this
      const { title } = this.report
      return ext ? `${title}.${ext}` : title
    },
  },
  created() {
    const api = new ReportsApi()
    this.adapter = new Adapter(api)

    this.getOrCreateReport()
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    async getOrCreateReport() {
      try {
        this.isLoadingData = true

        const params = {
          code: ReportCodes[this.reportCode],
          params: this.params,
        }

        const { data } = await this.adapter.create(params)
        if (data.id) {
          this.checkStatus(data.id)
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoadingData = false
      }
    },
    async checkStatus(id) {
      try {
        this.isLoadingData = true

        const { data } = await this.adapter.getOne(id)
        this.report = data

        if (data.status !== ReportStatuses.done && data.status !== ReportStatuses.error) {
          this.timerId = setTimeout(() => {
            this.checkStatus(id)
          }, STATUS_TIMEOUT)
        } else {
          clearTimeout(this.timerId)
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoadingData = false
      }
    },
    async onDownloadReport() {
      this.isLoading = true

      const splitUrl = this.report.raw_file.url.split('/')
      const filename = this.report.name || `${decodeURI(splitUrl[splitUrl.length - 1])}.xlsx`

      try {
        await downloadLinkByGet(this.report.raw_file.url, filename)
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$content-padding: 12px;

.LKPublicationsFormdataReport {
  padding: $content-padding;

  &__header {
    margin-bottom: 12px;

    * {
      display: inline-block;
    }

    &__title + * {
      margin-left: 12px;
    }
  }

  &__btn {
    display: block;
    padding: 8px 16px;
    margin: 4px auto;
    font-size: 12px;
    font-weight: 600;
    color: $webflow-color-white;
    background-color: $webflow-color-blue-dark;
    border-radius: 100px;
    transition: background-color $webflow-transition;

    &:hover {
      background-color: $webflow-color-blue-dark-hover;
    }

    &[disabled] {
      background-color: $webflow-color-grey;
    }
  }
}
</style>
